import { Outlet } from "react-router-dom";

import { useAppContext } from "../../context/AppContext.jsx";

function Content() {
  const { appContentClass } = useAppContext();

  return (
    <div className={"app-content " + appContentClass}>
      <Outlet />
    </div>
  );
}

export default Content;
